<div class="object__button flex justify-end">
    <a id="link-edit-{{userObject.onlineId}}" class="btn btn--100 btn--secondary btn--full-width" data-cy="edit-button" (click)="onModalOpen()">Anzeige bearbeiten</a>
</div>
